export const VERSION_HEADER_KEY = 'x-request-webappversion';
export const ROUTER_BASENAME = '/support';
